import { Employee } from '@/types/employee';
import { postEdgeFunctionAction } from './postEdgeFunctionAction';

export class EmployeeApiClient {
  private async callApi(action: string, data: Record<string, unknown> = {}): Promise<any> {
    return postEdgeFunctionAction('employee-api', action, data);
  }

  async listEmployees(): Promise<Employee[]> {
    return this.callApi('list');
  }

  async getByUserId(): Promise<Employee | null> {
    return this.callApi('getByUserId');
  }

  async createEmployee(data: { name?: string; iban?: string; userId?: string }): Promise<Employee> {
    return this.callApi('create', data);
  }

  async updateEmployee(employeeId: string, data: { name?: string | null; iban?: string | null }): Promise<Employee> {
    return this.callApi('update', { employeeId, ...data });
  }

  async mergeEmployee(sourceId: string, targetId: string): Promise<Employee> {
    return this.callApi('merge', { sourceEmployeeId: sourceId, targetEmployeeId: targetId });
  }

  async deleteEmployee(employeeId: string): Promise<void> {
    await this.callApi('delete', { employeeId });
  }
}
